export function getEvaluableIndicesMap(
  evaluableIds: string[],
  holdEvaluableId: string,
): { [evaluableId: string]: number } {
  const evaluableIndicesMap: { [evaluableId: string]: number } = {
    [holdEvaluableId]: 0,
  };

  let numEvaluables = 1;

  for (const evaluableId of evaluableIds) {
    if (evaluableIndicesMap[evaluableId] || evaluableId === holdEvaluableId) {
      continue;
    }

    evaluableIndicesMap[evaluableId] = numEvaluables;
    numEvaluables++;
  }

  return evaluableIndicesMap;
}
